module.exports = __webpack_public_path__ + "img/4.7dd6e35e.jpg";